/**
 * Transkripti textarea caret konumuna yapıştırır (ChatGPT davranışı).
 * Mevcut satır sonlarını / boşlukları korur; gerekirse akıllı boşluk ekler.
 */
export const insertTextAtCaret = (
  value: string,
  rawText: string,
  caret: { start: number; end: number }
): { next: string; caret: number } => {
  const transcript = rawText.trim();
  if (!transcript) {
    return { next: value, caret: caret.start };
  }

  const start = Math.max(0, Math.min(caret.start, value.length));
  const end = Math.max(start, Math.min(caret.end, value.length));
  const before = value.slice(0, start);
  const after = value.slice(end);

  let insert = transcript;
  // Öncesi harf/rakam ile bitiyorsa ve transcript noktalama ile başlamıyorsa boşluk ekle
  if (
    before.length > 0 &&
    !/\s$/.test(before) &&
    !/^[.,!?;:\n]/.test(transcript)
  ) {
    insert = ` ${transcript}`;
  }

  const next = before + insert + after;
  return { next, caret: before.length + insert.length };
};
